import { FormRadio, FormRadioGroup } from 'components/form/FormRadioGroup';
import { FlexColumn, Grid } from 'components/form/generic';
import LabelledCheckbox from 'components/form/Inputs/LabelledCheckbox';
import Radio from 'components/form/Inputs/Radio';
import EXPECTATIONS from 'enums/MenteeExpectations';
import TitleList from 'components/form/TitleList';
import Field from 'components/profileNavigation/Field';
import CONSIDERATIONS from 'enums/Considerations';
import EXPERTISE from 'enums/Expertise';
import FORMATIONS from 'enums/Formation';
import FORMATION_PROJECT_MATCHES from 'enums/FormationProjectMatches';
import FORMATION_STATES from 'enums/FormationState';
import HOBBIES from 'enums/Hobby';
import MENTEE_HEARD_ABOUT_MENTORSHIP from 'enums/MenteeHeardAboutMentorship';
import { MENTEE_PRIORITY_LEVELS } from 'enums/PriorityLevels';
import STUDY_LEVELS from 'enums/StudyLevels';
import VOLUNTEER_STATES from 'enums/VolunteerState';
import { FC } from 'react';
import MenteeForm from 'types/MenteeForm';
import { PermissionsContainer, RadiosContainer } from './components';

type Props = {
  menteeForm: MenteeForm | undefined;
  variant?: 'mentor' | 'default';
};
const MenteeFormDisplay: FC<Props> = ({ menteeForm, variant }) => {
  return (
    <>
      <Field label="Appuis recherchés">
        <FlexColumn>
          <FormRadioGroup
            title="L'amélioration des techniques de recherche d'emploi"
            name="job_search"
            value={menteeForm?.jobSearch || null}
            readOnly
          >
            <FormRadio
              label={MENTEE_PRIORITY_LEVELS['PRIORITY']}
              id="PRIORITY"
            />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['YES']} id="YES" />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['NO']} id="NO" />
          </FormRadioGroup>
          <FormRadioGroup
            title="Définition du projet de formation ou projet professionnel"
            name="career_plan"
            value={menteeForm?.careerPlan || null}
            readOnly
          >
            <FormRadio
              label={MENTEE_PRIORITY_LEVELS['PRIORITY']}
              id="PRIORITY"
            />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['YES']} id="YES" />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['NO']} id="NO" />
          </FormRadioGroup>
          <FormRadioGroup
            title="Conseils pour réussir dans ses études"
            name="studies"
            value={menteeForm?.studies || null}
            readOnly
          >
            <FormRadio
              label={MENTEE_PRIORITY_LEVELS['PRIORITY']}
              id="PRIORITY"
            />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['YES']} id="YES" />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['NO']} id="NO" />
          </FormRadioGroup>
          <FormRadioGroup
            title="Création ou développement d'une activité"
            name="entrepreneurship"
            value={menteeForm?.entrepreneurship || null}
            readOnly
          >
            <FormRadio
              label={MENTEE_PRIORITY_LEVELS['PRIORITY']}
              id="PRIORITY"
            />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['YES']} id="YES" />
            <FormRadio label={MENTEE_PRIORITY_LEVELS['NO']} id="NO" />
          </FormRadioGroup>
          <TitleList title="Partage">
            <LabelledCheckbox
              label="Le mentoré souhaite pouvoir partager avec un mentor de façon générale"
              readOnly
              checked={!!menteeForm?.sharing}
            />
          </TitleList>
        </FlexColumn>
      </Field>

<Field label="Votre volontariat ou bénévolat">
  {menteeForm?.volunteerState && VOLUNTEER_STATES[menteeForm.volunteerState] ? (
    <RadiosContainer>
      <Radio
        label={VOLUNTEER_STATES[menteeForm.volunteerState]}
        checked={true}
        readOnly
      />
    </RadiosContainer>
  ) : (
    <p>Non renseigné ou format inconnu ({String(menteeForm?.volunteerState)})</p>
  )}
</Field>

      <Field label="Domaines de compétences">
        <Grid>
          {menteeForm?.expertiseFields?.map((expertiseField) => (
            <LabelledCheckbox
              key={expertiseField.id}
              readOnly
              checked
              label={EXPERTISE[expertiseField.expertise]}
            />
          ))}
        </Grid>
      </Field>

      <Field label="Niveau de diplôme">
        <Radio
          label={
            menteeForm?.validatedDiploma
              ? STUDY_LEVELS[menteeForm.validatedDiploma]
              : 'Non précisé'
          }
          checked={!!menteeForm?.validatedDiploma}
          readOnly
        />
      </Field>
      <Field label="Type de formation">
        <Radio
          readOnly
          checked={!!menteeForm?.completedFormation}
          label={
            menteeForm?.completedFormation
              ? FORMATIONS[menteeForm.completedFormation]
              : 'Non précisé'
          }
        />
      </Field>

      <Field label="Formation correspondant au projet ?">
        <RadiosContainer>
          <Radio
            label={FORMATION_PROJECT_MATCHES['YES']}
            checked={menteeForm?.formationMatchingProject === 'YES'}
            readOnly
          />
          <Radio
            label={FORMATION_PROJECT_MATCHES['NO']}
            checked={menteeForm?.formationMatchingProject === 'NO'}
            readOnly
          />
          <Radio
            label={FORMATION_PROJECT_MATCHES['NOT_CONCERNED']}
            checked={menteeForm?.formationMatchingProject === 'NOT_CONCERNED'}
            readOnly
          />
        </RadiosContainer>
      </Field>

      <Field label="Formation correspondant au projet">
        <Radio
          readOnly
          checked={!!menteeForm?.intendedFormation}
          label={
            menteeForm?.intendedFormation
              ? FORMATIONS[menteeForm.intendedFormation]
              : 'Non précisé'
          }
        />
      </Field>

      <Field label="Formation déjà commencée ?">
        <Radio
          readOnly
          checked={!!menteeForm?.formationState}
          label={
            menteeForm?.formationState
              ? FORMATION_STATES[menteeForm.formationState]
              : 'Non précisé'
          }
        />
      </Field>

      <Field label="Niveau de diplôme visé">
        <Radio
          label={
            menteeForm?.intendedDiploma
              ? STUDY_LEVELS[menteeForm.intendedDiploma]
              : 'Non précisé'
          }
          checked={!!menteeForm?.intendedDiploma}
          readOnly
        />
      </Field>

      {variant !== 'mentor' && (
        <Field label="Rural/Urbain">
          <Radio
            readOnly
            checked={!!menteeForm?.consideration}
            label={
              menteeForm?.consideration
                ? CONSIDERATIONS[menteeForm.consideration]
                : 'Non précisé'
            }
          />
        </Field>
      )}

      {variant !== 'mentor' && (
        <Field label="Temps libre">
          <Radio
            readOnly
            checked={!!menteeForm?.hobby}
            label={
              menteeForm?.hobby ? HOBBIES[menteeForm.hobby] : 'Non précisé'
            }
          />
        </Field>
      )}

      {variant !== 'mentor' && (
        <Field label="Comment avez-vous entendu parler du mentorat ?">
          {menteeForm?.heardAboutMentorship === 'OTHER'
            ? menteeForm.heardAboutMentorshipText || 'Autre (non précisé)'
            : menteeForm?.heardAboutMentorship &&
              MENTEE_HEARD_ABOUT_MENTORSHIP[menteeForm.heardAboutMentorship]}
        </Field>
      )}

      <Field label="Ce que j'attends du mentorat">
        <FlexColumn gap={0.5}>
          {(menteeForm?.expectations || '').split(',').filter(Boolean).map((expectation) => (
            <LabelledCheckbox
              key={expectation}
              label={EXPECTATIONS[expectation] || expectation}
              checked
              readOnly
            />
          ))}
        </FlexColumn>
      </Field>

      {variant !== 'mentor' && (
        <Field label="Partage des informations avec le mentor">
          <PermissionsContainer>
            <LabelledCheckbox
              label="J’autorise le partage de mon adresse email avec le mentor"
              checked={!!menteeForm?.sharingEmail}
              readOnly
            />
            <LabelledCheckbox
              label="J’autorise le partage de mon numéro de téléphone avec le mentor"
              checked={!!menteeForm?.sharingPhone}
              readOnly
            />
            <div className="or">OU</div>
            <LabelledCheckbox
              label="Je n’autorise pas le partage de mes informations avec le mentor"
              checked={
                menteeForm?.sharingEmail === false &&
                menteeForm?.sharingPhone === false
              }
              readOnly
            />
          </PermissionsContainer>
        </Field>
      )}
    </>
  );
};

export default MenteeFormDisplay;
